export class TelephoneNumber {
    constructor(
      public area: string,
      public exchange: string,
      public subscriber: string
    ) {}

      format = () => `(${this.area}) ${this.exchange}-${this.subscriber}`;
  }